import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import moment from 'moment'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableBody from '@material-ui/core/TableBody'
import Table from '@material-ui/core/Table'
import Tooltip from '@material-ui/core/Tooltip'
import messages from 'components/Apps/SlaMonitor/translate'
import {
  setEnvironmentModule,
  setShowChartModal,
  setChartType,
  fetchWeatherData,
} from 'reducers/slaMonitor/environment/reducer'
import licenseeDigitFormat from 'helpers/licenseeDigitFormat'

class ModuleA extends Component {
  componentDidMount() {
    const { activeSite, activeDate, fetchWeatherData } = this.props

    fetchWeatherData({
      site: activeSite,
      now: activeDate.utc().format('YYYY-MM-DD HH:mm:ss'),
    })
  }

  shouldComponentUpdate(nextProps) {
    const { activeSite, activeDate, fetchWeatherData } = this.props
    const { activeSite: nextActiveSite, activeDate: nextActiveDate } = nextProps

    if (activeSite !== nextActiveSite || activeDate !== nextActiveDate) {
      fetchWeatherData({
        site: nextActiveSite,
        now: nextActiveDate.utc().format('YYYY-MM-DD HH:mm:ss'),
      })

      return false
    }

    return true
  }

  getTooltipContent = (depth, param, value, time) => {
    const {
      intl: { formatMessage },
    } = this.props

    return (
      <>
        <div>{depth}</div>
        <div>
          {param}: {value}
        </div>
        <div>
          {formatMessage(messages.lastUpdate)}:{' '}
          {time ? moment(time).format('HH:mm') : '--:--'}
        </div>
      </>
    )
  }

  render() {
    const {
      intl: { formatMessage },
      licensee,
    } = this.props
    const weatherData = this.props.weatherData.toJS()

    return (
      <Table aria-label="simple table" className="env-table">
        <TableHead>
          <TableRow>
            <TableCell align="left" className="env-table-cell">
              {' '}
            </TableCell>
            <TableCell align="center" className="env-table-cell">
              {formatMessage(messages.now)}
            </TableCell>
            <TableCell align="center" className="env-table-cell">
              {formatMessage(messages.max)}
            </TableCell>
            <TableCell align="center" className="env-table-cell">
              {formatMessage(messages.min)}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(weatherData).map((key, index) => {
            const { now, high, low, last_updated } = weatherData[key]
            const label = formatMessage(messages[`weather_${key}`])
            const valueNow = now ? licenseeDigitFormat(now, licensee) : '--'
            const valueHigh = high ? licenseeDigitFormat(high, licensee) : '--'
            const valueLow = low ? licenseeDigitFormat(low, licensee) : '--'

            return (
              <TableRow key={index}>
                <TableCell align="left" className="env-table-cell">
                  {label}
                </TableCell>
                <TableCell align="center" className="env-table-cell">
                  <Tooltip
                    title={this.getTooltipContent(
                      formatMessage(messages.now),
                      label,
                      valueNow,
                      last_updated,
                    )}>
                    <span className="environment-cell">{valueNow}</span>
                  </Tooltip>
                </TableCell>
                <TableCell align="center" className="env-table-cell">
                  <Tooltip
                    title={this.getTooltipContent(
                      formatMessage(messages.high),
                      label,
                      valueHigh,
                      last_updated,
                    )}>
                    <span className="environment-cell">{valueHigh}</span>
                  </Tooltip>
                </TableCell>
                <TableCell align="center" className="env-table-cell">
                  <Tooltip
                    title={this.getTooltipContent(
                      formatMessage(messages.low),
                      label,
                      valueLow,
                      last_updated,
                    )}>
                    <span className="environment-cell">{valueLow}</span>
                  </Tooltip>
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    )
  }
}

export default connect(
  state => ({
    activeSite: state.getIn(['profile', 'siteId']),
    activeDate: state.getIn(['slaMonitor', 'activeDate']),
    module: state.getIn(['environment', 'module']),
    weatherData: state.getIn(['environment', 'weatherData']),
    licensee: state.getIn(['profile', 'profile', 'licensee']),
  }),
  {
    setEnvironmentModule,
    setShowChartModal,
    setChartType,
    fetchWeatherData,
  },
)(injectIntl(ModuleA))
